"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
var constants_1 = require("utils/constants");
var search_1 = require("utils/search");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('tempValue', 'setTempValue', null), recompose_1.pure);
var clearSearchCross = function (props) {
    return (React.createElement("span", { className: 'file-list-search-box-right' }, typeof props.queryParams.search === 'string' &&
        props.queryParams.search.length > 0 && (React.createElement(Icon_1.Icon, { onClick: function () {
            return props.updateUrl(props.pathname +
                (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: '' })));
        }, className: "fa-times" }))));
};
var timeout = null;
exports.SearchBar = enhance(function (props) { return (React.createElement("div", { className: 'search-area' },
    React.createElement(sok_ui_1.TextInput, { value: (props.tempValue === null
            ? props.queryParams.search
            : props.tempValue) || '', placeholder: (0, translation_1.getLocalization)('subprojectListView/search/placeholder'), onChange: function (e) {
            var value = e.target.value;
            props.setTempValue(value);
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                props.updateUrl(props.pathname +
                    (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: value })));
                props.setTempValue(null);
            }, constants_1.SEARCH_TIMEOUT);
        }, icon: React.createElement(Icon_1.Icon, { key: "icon", className: 'fa-search' }), iconRight: clearSearchCross(props) }))); });
